import { render, staticRenderFns } from "./level2ImportAsc.vue?vue&type=template&id=5ae4f3bb&scoped=true&"
import script from "./level2ImportAsc.vue?vue&type=script&lang=js&"
export * from "./level2ImportAsc.vue?vue&type=script&lang=js&"
import style0 from "./level2ImportAsc.vue?vue&type=style&index=0&id=5ae4f3bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae4f3bb",
  null
  
)

export default component.exports